/*
 * @Author: zxf
 * @Date: 2022-04-02 10:38:54
 * @Description: 方法集合
 */

function Methods(ext) {
  this.ext = ext;
}

/** 模型切换 */
Methods.prototype.modelSwitch = function () {
  // 清理模型相关状态
};

/** 模式改变 */
Methods.prototype.modeChange = function (params) {
  // 处理模式改变
};

/** 正在切换全景点 */
Methods.prototype.switchPano = function (params) {
  // 处理全景点切换
};

Methods.prototype.setDirection = function (radian) {
  if (this.ext.compass3d) {
    this.ext.compass3d.updatePose(radian);
  }
};

Methods.prototype.show = function () {
  if (this.ext.compass3d) {
    this.ext.compass3d.show();
    this.ext.compass3d.updatePose(this.ext.radian);
    this.ext.isVisible = true;
  }
};

Methods.prototype.hide = function () {
  if (this.ext.compass3d) {
    this.ext.compass3d.hide();
    this.ext.isVisible = false;
  }
};

module.exports = Methods;
